import { render, staticRenderFns } from "./ExtraFieldBoolOptions.vue?vue&type=template&id=da9c5abc"
import script from "./ExtraFieldBoolOptions.vue?vue&type=script&lang=ts"
export * from "./ExtraFieldBoolOptions.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/winfakt/wf/v2.online.dev/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('da9c5abc')) {
      api.createRecord('da9c5abc', component.options)
    } else {
      api.reload('da9c5abc', component.options)
    }
    module.hot.accept("./ExtraFieldBoolOptions.vue?vue&type=template&id=da9c5abc", function () {
      api.rerender('da9c5abc', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/settings-default/ExtraFieldBoolOptions.vue"
export default component.exports